module.exports = __webpack_public_path__ + "img/platform_hungerbox_logo.66f66c55.png";